import styled, { css } from 'styled-components';
export const Image = styled.img(({ objectFit }) => css `
    width: 100%;
    height: 100%;
    max-height: 1000px;
    object-fit: ${objectFit};
  `);
